export const BACKGROUND_COLOR = "#0f172a";
export const EMPTY_CELL_COLOR = "#1e293b";
export const CELL_BORDER_COLOR = "#0f172a";
export const HOVER_BORDER_COLOR = "#fbbf24";
export const TARGET_INDICATOR_COLOR = "#22c55e";

export function getCellColor(color: string | null): string {
  return color ?? EMPTY_CELL_COLOR;
}

// Lighter version for capacity bar background
export function getCellColorDim(color: string | null): string {
  if (!color) return "#334155";
  // Darken by mixing with black
  return color + "44";
}
